module.exports = __webpack_public_path__ + "img/poland.b0f90d1b.svg";